import { render, staticRenderFns } from "./StoreForm.vue?vue&type=template&id=4a2f12b6&"
import script from "./StoreForm.vue?vue&type=script&lang=js&"
export * from "./StoreForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports